import { mapValue, random_bool, random_int, random_num } from "../common/utils";
import { fxrand, registerFeatures } from "../fxhash";

const SACRED = random_bool(0.33);
const SPEED = random_num(10, 40);
const NOISE_LEVEL = random_num(0.25, 0.5);
const FACTOR = random_num(0.5, 1);
const RIPPLES = Math.round(random_num(5, 80));

const baseHue = random_num(0, 360);

const elements = [
  "fire",
  "mineral",
  "forest",
  "earth",
  "water",
  "air",
  "plasma",
  "fire",
];
const elementIndex = Math.round(
  mapValue(baseHue, 0, 360, 0, 1) * (elements.length - 1)
);
const element = elements[elementIndex];

const palette = {
  bg: `hsl(${baseHue}, 30%, 10%)`,
  crystalBall: `hsl(${baseHue}, 80%, 90%)`,
  crystals: [
    `hsl(${Math.abs((baseHue + 10) % 360)}, 70%, 50%)`,
    `hsl(${Math.abs((baseHue - 10) % 360)}, 70%, ${
      element === "air" ? 80 : 50
    }%)`,
    `hsl(${Math.abs((baseHue + 20) % 360)}, 70%, 50%)`,
    `hsl(${baseHue}, 70%, 50%)`,
    `hsl(${baseHue}, 70%, ${element === "air" ? 60 : 50}%)`,
  ],
};

if (SACRED) {
  palette.crystals.splice(4, 0, `hsl(${baseHue}, 0%, 100%)`);
}

const crystalColor = palette.crystals[palette.crystals.length - 1];

registerFeatures({
  element: element,
  sacred: SACRED,
  speed: ["slow", "medium", "fast"][Math.round(mapValue(SPEED, 10, 40, 0, 2))],
  noise: ["clean", "static"][
    Math.round(mapValue(NOISE_LEVEL, 0.25, 0.5, 0, 1))
  ],
  ripples: RIPPLES,
  fluidity: ["stable", "unstable"][Math.round(mapValue(FACTOR, 0.5, 1, 0, 1))],
});

const crystals = [...Array(40)].map((crystal) => {
  const baseScale = 4;
  const scaling = 0.9; // random_num(0.1, 0.9) * (baseScale / 4);
  return {
    scale: [scaling, scaling * random_num(0.3, 0.8), scaling],
    posX: random_num(-1.1 * (baseScale / 4), 1.1 * (baseScale / 4)),
    posY: random_num(-1.3 + baseScale / 4, 2.5 - scaling) - 2,
    posZ: random_num(-1.1 * (baseScale / 4), 1.1 * (baseScale / 4)),
  };
});

const context = {
  element: element,
  sacred: SACRED,
  speed: SPEED,
  noise: NOISE_LEVEL,
  ripples: RIPPLES,
  fluidity: FACTOR,
  palette: palette,
  baseHue: baseHue,
  crystalColor: crystalColor,
  seed: fxrand(),
  thickness: random_num(0.14, 0.3),
  octave: random_int(2, 4),
  crystals: crystals,
  recording: {
    video: false,
    audio: false,
  },
};

export const featuresContext = context;
